import {findInGroupFilters} from '../utils/filterPillUtils';
import {getGroupFiltersSelected} from '../utils/filters';
import {
    PRICE_FILTER_GROUP_ID,
    ROOMSANDSPACES_FILTER_GROUP_ID,
} from '../constants/filters';
import {FilterGroupType} from '../components/FilterBar/FilterBar';
import type {FilterGroupPillProps} from '../components/FilterGroupPill/FilterGroupPill';

type GetSelectionByGroup = Pick<
    FilterGroupPillProps,
    'filters' | 'selectedFilters' | 'customFiltersParams'
>;

type SelectionByGroup = {
    isPriceSelected: boolean;
    isBedroomOrBathroomSelected: boolean;
    isAnyCheckboxSelected: boolean;
};

// eslint-disable-next-line complexity
export function getSelectionByGroup({
    filters,
    selectedFilters,
    customFiltersParams,
}: GetSelectionByGroup): SelectionByGroup {
    const {
        selectedMaxNightlyPrice,
        selectedMinNightlyPrice,
        selectedMaxTotalPrice,
        selectedMinTotalPrice,
        selectedMinBedrooms,
        selectedMinBathrooms,
    } = customFiltersParams;
    const isAnyCheckboxSelected =
        getGroupFiltersSelected(filters, selectedFilters).length > 0;
    const isPriceSelected = [
        selectedMaxNightlyPrice,
        selectedMinNightlyPrice,
        selectedMaxTotalPrice,
        selectedMinTotalPrice,
    ].some((val) => !!val);
    const isBedroomOrBathroomSelected =
        !!selectedMinBedrooms || !!selectedMinBathrooms;

    return {
        isPriceSelected,
        isBedroomOrBathroomSelected,
        isAnyCheckboxSelected,
    };
}

type ShouldShowClearButton = {
    groupId?: string;
    selectionByGroup: SelectionByGroup;
    filterGroups?: FilterGroupType[];
};

// eslint-disable-next-line complexity
export function shouldShowClearButton({
    filterGroups,
    groupId,
    selectionByGroup,
}: ShouldShowClearButton): boolean {
    const {
        isPriceSelected,
        isBedroomOrBathroomSelected,
        isAnyCheckboxSelected,
    } = selectionByGroup;

    if (groupId) {
        if (groupId === PRICE_FILTER_GROUP_ID) {
            return isPriceSelected;
        } else if (groupId === ROOMSANDSPACES_FILTER_GROUP_ID) {
            return isBedroomOrBathroomSelected || isAnyCheckboxSelected;
        }
        return isAnyCheckboxSelected;
    } else if (filterGroups) {
        return [
            isAnyCheckboxSelected,
            findInGroupFilters(filterGroups, PRICE_FILTER_GROUP_ID)
                ? isPriceSelected
                : false,
            findInGroupFilters(filterGroups, ROOMSANDSPACES_FILTER_GROUP_ID)
                ? isBedroomOrBathroomSelected
                : false,
        ].some((selected) => selected);
    }

    return (
        isPriceSelected || isBedroomOrBathroomSelected || isAnyCheckboxSelected
    );
}
